import React, { Component } from 'react';

export default class Loader extends Component {
  render() {
    return <div className="loading">
        <img alt="Loading..." src="/assets/loading.svg"/>
      </div>
  }
}